<p-toast />
<p-confirmDialog />

<div class="quick-links-wrapper mt-2">
  <!-- Main Content Layout -->
  <div class="main-layout" *ngIf="!initialLoading()">
    <!-- Sidebar Toggle Area -->
    <div class="sidebar-toggle-area">
      <p-button
        [icon]="sidebarCollapsed() ? 'pi pi-angle-right' : 'pi pi-angle-left'"
        [text]="true"
        size="small"
        (onClick)="toggleSidebar()"
        [pTooltip]="sidebarCollapsed() ? 'Expand filters' : 'Collapse filters'"
        tooltipPosition="right"
        class="sidebar-toggle-btn"
      />

      <!-- Collapsed State with Filter Button -->
      <div class="collapsed-controls" *ngIf="sidebarCollapsed()">
        <button
          class="collapsed-filter-btn"
          (click)="toggleSidebar()"
          [pTooltip]="'Filters'"
          tooltipPosition="right"
        >
          <i class="pi pi-filter"></i>
          <div class="filter-dot-indicator" *ngIf="hasActiveFilters()">
            <i class="pi pi-circle-fill"></i>
          </div>
        </button>
        <!-- Clear All Button for Collapsed State -->
        <button
          *ngIf="hasActiveFilters()"
          class="collapsed-clear-btn"
          (click)="onClearFilters(); $event.stopPropagation()"
          [pTooltip]="'Clear All Filters'"
          tooltipPosition="right"
        >
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>

    <!-- Filter Sidebar -->
    <div class="filter-sidebar" [class.collapsed]="sidebarCollapsed()">
      <div class="sidebar-content">
        <app-quick-links-filters
          [filterForm]="filterForm"
          [loading]="loading()"
          [drawerMode]="true"
          (filtersChanged)="onFiltersChanged($event)"
          (clearFilters)="onClearFilters()"
        />
      </div>
    </div>

    <!-- Main Content Area -->
    <div class="content-area" [class.sidebar-open]="!sidebarCollapsed()">
      <!-- Compact Toolbar -->
      <div
        class="content-toolbar surface-section border-bottom-1 surface-border"
      >
        <div
          class="flex align-items-center justify-content-between p-3 justify-between"
        >
          <div class="flex align-items-center items-center">
            <span class="text-sm text-600">
              {{ data()?.pagination?.totalItems || 0 }} Quick Action Links
            </span>
          </div>
          <div class="flex align-items-center gap-2">
            <p-button
              label="Create"
              icon="pi pi-plus"
              size="small"
              (onClick)="openCreateDialog()"
            />
          </div>
        </div>
      </div>

      <!-- Table Container -->
      <div class="table-container flex-1 overflow-hidden">
        <app-quick-links-table
          [data]="data()"
          [loading]="loading()"
          scrollHeight="flex"
          (sortChanged)="onSortChanged($event)"
          (pageChanged)="onPageChanged($event)"
          (rowAction)="onRowAction($event)"
        />
      </div>
    </div>
  </div>

  <!-- Initial Loading Skeleton -->
  @if (initialLoading()) {
    <app-list-page-skeleton
      [sidebarCollapsed]="sidebarCollapsed()"
      filterPreset="quickLinks"
      tablePreset="quickLinks"
    />
  }
</div>
